<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Detail Requisition" subTitle="Forms" />

    <DetailRequisition />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import DetailRequisition from "@/components/Pages/Management/Requisition/DetailRequisition.vue";

export default defineComponent({
  name: "DetailRequisitionPage",
  components: {
    PageTitle,
    DetailRequisition,
  },
});
</script>
